function Quiz() {
  return (
    <h2>Quiz:</h2>
    
  )
}

export default Quiz